import apiClient from './client'
import type {
  Transcript,
  ListTranscriptsRequest,
  ListTranscriptsResponse,
  StatsResponse,
  FilterOptions
} from '@/types'

export const transcriptsApi = {
  list: async (params?: ListTranscriptsRequest): Promise<ListTranscriptsResponse> => {
    const response = await apiClient.get<ListTranscriptsResponse>('/transcripts', { params })
    return response.data
  },

  getById: async (id: string): Promise<Transcript> => {
    const response = await apiClient.get<Transcript>(`/transcripts/${id}`)
    return response.data
  },

  getAudioUrl: async (id: string): Promise<string> => {
    const response = await apiClient.get<{ url: string }>(`/transcripts/${id}/audio`)
    return response.data.url
  },

  getStats: async (params?: {
    period?: 'hour' | 'day' | 'week'
    start_date?: string
    end_date?: string
    room_name?: string
  }): Promise<StatsResponse> => {
    const response = await apiClient.get<StatsResponse>('/stats', { params })
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/transcripts/${id}`)
  },

  getFilterOptions: async (): Promise<FilterOptions> => {
    const response = await apiClient.get<FilterOptions>('/transcripts/filters')
    return response.data
  },

  reprocess: async (id: string): Promise<{ id: string; summary: string }> => {
    const response = await apiClient.post<{ id: string; summary: string }>(
      `/transcripts/${id}/reprocess`,
      {},
      { timeout: 600_000 } // 10min — Ellen LLM pode demorar
    )
    return response.data
  },
}
